import React from 'react'
import classes from "./SectionHeading.module.css"
import { useTranslation } from 'react-i18next'

const SectionHeading = () => {
    const {t}=useTranslation();
    return (
        <div className={classes.section_heading}>
            <div className={classes.section_heading_top}>
                <span className={classes.section_badge}>{t("62")}</span>
                <span className={classes.section_line}></span>
            </div>

            {/* <h2 className={classes.section_title}> */}
                {/* Top <span>UV Played</span> Games */}
            {/* </h2> */}

            {/* <p className={classes.section_subtitle}>
                Jump into the most played titles loved by UV gamers right now.
            </p> */}
        </div>
    )
}

export default SectionHeading